/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { WorkItemManager } from "WorkItemTracking/Scripts/OM/WorkItemManager";
import TMUtils = require("TestManagement/Scripts/TFS.TestManagement.Utils");

export interface IRemoveWorkItemsProps {
    workItemIds: number[];
}

// This is a proxy component to remove the work item from cache using LegacyComponent
class RemoveWorkItemsProxy extends React.Component<IRemoveWorkItemsProps, {}>{
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        if (this.props.workItemIds){
            let witStore = TMUtils.WorkItemUtils.getWorkItemStore();
            WorkItemManager.get(witStore).invalidateCache(this.props.workItemIds);
        }
    }
}

registerLWPComponent("remove-work-item-proxy", RemoveWorkItemsProxy);